<script>
/**
 * Admin / Customer
 * Type         : Business component
 * Title        : Order등록 컴포넌트
 * Description  : 신규배송을 생성할 경우 사용하는 컴포넌트
 *              - 보내는 사람
 *              - 받는 사람
 *              - 오더 기본정보, 추가정보
 *              - 오더 상품정보
 */

import { ref } from 'vue'
import OrderItemRegiFormUnit from "@/components/common/modal/OrderItemRegiFormUnit.vue"

export default {
  name: "NewOrderComponent",
  components: {
    OrderItemRegiFormUnit
  },
  emits:[
    "close-modal",  // 모달 닫기 이벤트
    "refresh-list"  // 리스트 새로고침 이벤트
  ],
  props: {
    memberId: String,
    partnerId: String
  },
  computed: {
    totalItemPrice () {
      return this.itemList.reduce((total, item) => {
        return total + (item.unitPrice * item.itemQty)
      }, 0)
    },
    canUseFulfillmentBarcode () {
      if (Number(this.session?.authLevel) >= 90) return true
      return this.toBool(this.session?.has_fulfillment_contract)
    }
  },
  data() {
    return {
      mode    : 0,
      idx     : 0,
      regType : 'admin',
      session : this.$store.getters.getLocalSession,

      step    : ref(0),
      confirmed : false,

      orderItemModalShow : false,

      
      orderForm: {

        // 기본정보
        orderId       : '', // 오더번호
        customerNum   : 999999999, // 고객 ID
        freightMethod : '', // 운송수단 ('1'=해상, '2'=항공 등)
        consoleId     : null, // 콘솔 ID
        hblNo         : '', // H B/L 번호


        // 추가정보
        needClearance   : "N", // 일반통관 여부 ("Y"=목록, "N"=일반)
        customsCategory : 'D', // 통관 구분 코드


        // 배송정보
        courierCode : '', // 택배사명
        courierNum  : '', // 택배 송장번호
        

        // 유형별 추가정보
        ecommerceType     : '', // 전자상거래 유형 코드
        overSeasSellerCode: '', // 해외판매자 부호
        overSeasSellerName: '', // 해외판매자 상호
        shippingAgencyCode: '', // 구매/배송대행업체 부호
        shippingAgencyName: '', // 구매/배송대행업체 상호
        sellerAgencyCode  : '', // 판매대행업체 부호
        sellerAgencyName  : '', // 판매대행업체 상호
        

        // ORDER 일반 정보
        width   : 10.0, // 가로(cm)
        length  : 10.0, // 세로(cm)
        height  : 10.0, // 높이(cm)
        weight  : 0.0, // 중량(kg)
        boxQty  : 1, // 박스 수량
        siteUrl : '', // 구매사이트 URL


        // 보내는 사람정보
        shipperName   : '', // 보내는 사람 이름
        shipperMobile : '', // 보내는 사람 전화번호
        shipperAddress: '', // 보내는 사람 주소
        

        // 받는 사람정보
        receiverType    : null, // 받는 사람 구분 (1=개인, 2=사업자 등)
        receiverName    : '', // 받는 사람 이름
        receiverTel     : '', // 받는 사람 전화
        receiverMobile  : '', // 받는 사람 휴대폰
        receiverZipcode : '', // 받는 사람 우편번호
        receiverAddress1: '', // 받는 사람 주소
        receiverAddress2: '', // 받는 사람 상세주소
        pcc             : '', // 개인통관고유부호 또는 사업자번호
        orderMemo       : '', // 배송메모
        

        // 통관요청사항
        customsRequest  : '', // 통관 시 요청사항
        deliveryRequest : '', // 배송 요청사항
      },
      
      orderFormDef : {

        // 기본정보
        orderId       : '', // 오더번호
        customerNum   : 999999999, // 고객 ID
        freightMethod : '', // 운송수단 ('1'=해상, '2'=항공 등)
        consoleId     : null, // 콘솔 ID
        hblNo         : '', // H B/L 번호


        // 추가정보
        needClearance   : "N", // 일반통관 여부 ("Y"=목록, "N"=일반)
        customsCategory : 'D', // 통관 구분 코드


        // 배송정보
        courierCode : '', // 택배사명
        courierNum  : '', // 택배 송장번호
        

        // 유형별 추가정보
        ecommerceType     : '', // 전자상거래 유형 코드
        overSeasSellerCode: '', // 해외판매자 부호
        overSeasSellerName: '', // 해외판매자 상호
        shippingAgencyCode: '', // 구매/배송대행업체 부호
        shippingAgencyName: '', // 구매/배송대행업체 상호
        sellerAgencyCode  : '', // 판매대행업체 부호
        sellerAgencyName  : '', // 판매대행업체 상호
        

        // ORDER 일반 정보
        width   : 10.0, // 가로(cm)
        length  : 10.0, // 세로(cm)
        height  : 10.0, // 높이(cm)
        weight  : 0.0, // 중량(kg)
        boxQty  : 1, // 박스 수량
        siteUrl : '', // 구매사이트 URL


        // 보내는 사람정보
        shipperName   : '', // 보내는 사람 이름
        shipperMobile : '', // 보내는 사람 전화번호
        shipperAddress: '', // 보내는 사람 주소
        

        // 받는 사람정보
        receiverType    : null, // 받는 사람 구분 (1=개인, 2=사업자 등)
        receiverName    : '', // 받는 사람 이름
        receiverTel     : '', // 받는 사람 전화
        receiverMobile  : '', // 받는 사람 휴대폰
        receiverZipcode : '', // 받는 사람 우편번호
        receiverAddress1: '', // 받는 사람 주소
        receiverAddress2: '', // 받는 사람 상세주소
        pcc             : '', // 개인통관고유부호 또는 사업자번호
        orderMemo       : '', // 배송메모
        

        // 통관요청사항
        customsRequest  : '', // 통관 시 요청사항
        deliveryRequest : '', // 배송 요청사항
      },

      // 신규등록 배송상품
      itemList: [], // 배송상품 목록

      itemListOrigin : {
        barcode: '',             // 바코드
        itemName: '',            // 품명 (필수)
        brand: '',               // 브랜드
        itemQty: '',              // 수량
        unit: '',                // 단위 (예: 개, 박스 등)
        currency: 'USD',         // 통화 (예: USD, KRW)
        unitPrice: '',            // 단가
        weight: 10.00,            // 중량 (kg)
        height: 10.00,            // 높이 (cm)
        length: 10.00,            // 길이 (cm)
        width: 0.00,             // 넓이 (cm)
        volumeWeight: 0.000,     // 볼륨중량 (자동 계산 가능)
        url: '',                 // 상품 URL
        hsCode: '',              // HS CODE
      },

      columns : [
        { name: 'itemName', label: '품명', field: 'itemName', align: 'center', sortable: false},
        { name: 'brand', label: '브랜드', field: 'brand', align: 'center', sortable: false },
        { name: 'itemQty', label: '수량', field: 'itemQty', align: 'center', sortable: false },
        { name: 'unitPrice', label: '단가', field: 'unitPrice', align: 'center', sortable: false },
        // { name: 'unit', label: '단위', field: 'unit', align: 'center', sortable: false },
        // { name: 'currency', label: '통화', field: 'currency', align: 'center', sortable: false },
        // { name: 'weight', label: '중량 (kg)', field: 'weight', align: 'center', sortable: false },
        // { name: 'height', label: '높이 (cm)', field: 'height', align: 'center', sortable: false },
        // { name: 'length', label: '길이 (cm)', field: 'length', align: 'center', sortable: false },
        // { name: 'width', label: '넓이 (cm)', field: 'width', align: 'center', sortable: false },
        // { name: 'volumeWeight', label: '볼륨중량', field: 'volumeWeight', align: 'center', sortable: false },
        // { name: 'url', label: '상품 URL', field: 'url', align: 'center', sortable: false },
        // { name: 'hsCode', label: 'HS CODE', field: 'hsCode', align: 'center', sortable: false },
        {
          name: 'action',
          label: '삭제',
          field: 'action',
          align: 'center'
        }
      ],
    }
  },

  methods: {
    toBool(value) {
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') return value === 1
      const normalized = String(value ?? '').trim().toLowerCase()
      return ['1', 'true', 'y', 'yes'].includes(normalized)
    },

    /**
     * Title        : 오더 신규등록
     * Status       : Actived
     * Description  : 
     */
    async regOrder(){
      // 수량만큼의 배송상품을 등록시킨다.
      let payload = {
        // 파트너 및 등록자 정보
        partnerId     : this.partnerId,     // From props
        memberId      : this.memberId,      // From props

        customerNum   : this.orderForm.customerNum,
        freightMethod : this.orderForm.freightMethod,
        consoleId     : this.orderForm.consoleId,
        orderId       : this.orderForm.orderId,
        hblNo         : this.orderForm.hblNo,


        // 추가정보
        needClearance   : this.orderForm.needClearance,
        customsCategory : this.orderForm.customsCategory,


        // 배송정보
        courierCode   : this.orderForm.courierCode,
        courierNum    : this.orderForm.courierNum,


        // 유형별 추가정보
        ecommerceType     : this.orderForm.ecommerceType,
        overSeasSellerCode: this.orderForm.overSeasSellerCode,
        overSeasSellerName: this.orderForm.overSeasSellerName,
        shippingAgencyCode: this.orderForm.shippingAgencyCode,
        shippingAgencyName: this.orderForm.shippingAgencyName,
        sellerAgencyCode  : this.orderForm.sellerAgencyCode,
        sellerAgencyName  : this.orderForm.sellerAgencyName,


        // ORDER 일반 정보
        width     : this.orderForm.width,
        length    : this.orderForm.length,
        height    : this.orderForm.height,
        weight    : this.orderForm.weight,
        boxQty    : this.orderForm.boxQty,
        siteUrl   : this.orderForm.siteUrl,


        // 보내는 사람정보
        shipperName   : this.orderForm.shipperName,
        shipperMobile : this.orderForm.shipperMobile,
        shipperAddress: this.orderForm.shipperAddress,
        

        // 받는 사람정보
        receiverType    : this.orderForm.receiverType,
        receiverName    : this.orderForm.receiverName,
        receiverTel     : this.orderForm.receiverTel,
        receiverMobile  : this.orderForm.receiverMobile,
        receiverZipcode : this.orderForm.receiverZipcode,
        receiverAddress1: this.orderForm.receiverAddress1,
        receiverAddress2: this.orderForm.receiverAddress2,
        pcc             : this.orderForm.pcc,
        orderMemo       : this.orderForm.orderMemo,


        // 통관요청사항
        customsRequest    : this.orderForm.customsRequest,
        deliveryRequest   : this.orderForm.deliveryRequest,


        // 상품정보
        itemList: this.itemList.map(item => ({
          barcode     : item.barcode,
          itemName    : item.itemName,
          brand       : item.brand,
          itemQty     : item.itemQty,
          unit        : item.unit,
          currency    : item.currency,
          unitPrice   : item.unitPrice,
          weight      : item.weight,
          height      : item.height,
          length      : item.length,
          width       : item.width,
          volumeWeight: this.calculateVolumeWeight(item),
          url         : item.url,
          hsCode      : item.hsCode
        }))
      }

      payload.regType = this.regType

      let config = {
        method  : "POST",
        url     : "/api/parcel/registerOrderByCustomer",
        data    : payload,
        name    : "[ Axios / 오더 등록 ]"
      }

      this.$http(config)
        .then(res => {
          this.$log.debug("오더 등록 번째 등록내용", res)
          
          
          this.orderForm = this.orderFormDef
          this.itemList = [this.itemListOrigin] // 초기화
          this.step = 0
          
          this.confirmed = false

          this.$q.dialog({
            title: this.regType === 'customer' ? '배송요청 접수 완료' : '확인',
            message: this.regType === 'customer'
              ? '배송요청이 접수되었습니다. 담당자가 확인 후 운송장과 진행상태를 업데이트합니다.'
              : '상품등록에 성공했습니다.',
            cancel: false, // 취소 버튼 보임
            persistent: true // ESC로 닫기 방지 (옵션)
          }).onOk(() => {
            this.$emit("close-modal") // 모달 닫기 이벤트
            this.$emit("refresh-list") // 리스트 새로고침 이벤트. !!!! 페이지가 새로고침 됨. 위치를 바꾸지 말 것
          })
          
        }).catch(res => {
          this.$log.debug("/parcel/registerOrder 실패", res)
          this.$q.dialog({
            message: this.regType === 'customer' ? '배송요청 제출에 실패했습니다.' : '상품등록을 실패했습니다.',
          })
        })
    },


    /**
     * Title        : 필수값 체크
     * Status       : Actived
     * Description  : 필수값 체크 로직
     * @returns {boolean} - 필수값 체크 결과
     */
    validateOrderForm() {
      const requiredFields = [
        // 기본정보
        // { field: 'freightMethod', label: '운송수단' },
        // { field: 'orderId', label: '오더번호' },
        // { field: 'hblNo', label: 'HBL 번호' },

        // 추가정보
        { field: 'needClearance', label: '일반통관 여부' },
        { field: 'customsCategory', label: '통관 구분 코드' },

        // 배송정보
        // { field: 'courierCode', label: '택배사명' },
        // { field: 'courierNum', label: '택배 송장번호' },

        // 유형별 추가정보
        /*
        { field: 'ecommerceType', label: '전자상거래 유형 코드' },
        { field: 'overSeasSellerCode', label: '해외판매자 부호' },
        { field: 'overSeasSellerName', label: '해외판매자 상호' },
        { field: 'shippingAgencyCode', label: '구매/배송대행업체 부호' },
        { field: 'shippingAgencyName', label: '구매/배송대행업체 상호' },
        { field: 'sellerAgencyCode', label: '판매대행업체 부호' },
        { field: 'sellerAgencyName', label: '판매대행업체 상호' },
        */

        // ORDER 일반 정보
        // { field: 'width', label: '가로(cm)' },
        // { field: 'length', label: '세로(cm)' },
        // { field: 'height', label: '높이(cm)' },
        // 실제 무게는 고객 등록 시점에는 모를 수 있으므로 운송장 출력 시점에 검사한다.
        // { field: 'weight', label: '중량(kg)' },
        // { field: 'boxQty', label: '박스 수량' },
        // { field: 'siteUrl', label: '해외판매 홈페이지' },
        

        // 보내는 사람정보
        { field: 'shipperName', label: '보내는 사람 이름' },
        { field: 'shipperMobile', label: '보내는 사람 전화번호' },
        { field: 'shipperAddress', label: '보내는 사람 주소' },


        // 받는 사람정보
        { field: 'receiverType', label: '받는 사람 구분' },
        { field: 'receiverName', label: '받는 사람 이름' },
        { field: 'receiverTel', label: '받는 사람 전화번호' },
        { field: 'receiverMobile', label: '받는 사람 휴대폰' },
        { field: 'receiverZipcode', label: '받는 사람 우편번호' },
        { field: 'receiverAddress1', label: '받는 사람 주소' },
        { field: 'receiverAddress2', label: '받는 사람 상세주소' },
        { field: 'pcc', label: '개인통관고유부호' },
        // { field: 'orderMemo', label: '배송메모' },

        // 통관요청사항
        // { field: 'customsRequest', label: '통관 요청사항' },
        // { field: 'deliveryRequest', label: '배송 요청사항' },
      ];

      // Check each required field
      for (const { field, label } of requiredFields) {
        if (!this.orderForm[field]) {
          this.$q.dialog({
            message: `${label}은(는) 필수 입력 항목입니다.`,
          })
          return false;
        }
      }

      // Check itemList
      for (const item of this.itemList) {
        if (!item.itemName) {
          this.$q.dialog({
            message: '상품 목록의 품명은 필수 입력 항목입니다.',
          })
          return false;
        }
        if (!item.itemQty || item.itemQty <= 0) {
          this.$q.dialog({
            message: '상품 목록의 수량은 1 이상이어야 합니다.',
          })
          return false;
        }
      }

      return true;
    },



    /**
     * Title        : 오더 등록 전 필수값 체크
     * Status       : Actived
     * Description  : 오더 등록 전 필수값 체크
     */
    async preValidateOrderForm () {
      // 필수값 체크
      if(!this.validateOrderForm()){
        return
      }

      this.confirmed = true

      this.$q.dialog({
        title: this.regType === 'customer' ? '입력내용 확인 완료' : '확인',
        message: this.regType === 'customer'
          ? '입력내용을 확인했습니다. 배송요청 제출 버튼을 눌러 접수를 완료해 주세요.'
          : '등록 가능합니다',
      })
    },



    /**
     * Title        : 볼륨중량 계산
     * Status       : Actived
     * Description  : 볼륨중량 계산
     * @param item 
     */
    calculateVolumeWeight(item){
      const { length, width, height } = item
      return Number(((length * width * height) / 6000).toFixed(3))
    },


  
    /**
     * Title        : 행 삭제
     * Status       : Actived
     * Description  : 행 삭제
     * @param row 
     */
    removeRow(row) {
      if (this.itemList.length > 1) {
        // Remove the row from the itemList
        const index = this.itemList.indexOf(row)
        if (index !== -1) {
          this.itemList.splice(index, 1)
        }
      } else {
        this.$q.dialog({
          message: "최소 1개 이상의 상품이 필요합니다.",
        })
      }
    },
    updateItemAt(index, nextItem) {
      this.itemList.splice(index, 1, nextItem)
    },



    /**
     * Title        : 다음 단계로 이동
     * Status       : Actived
     * Description  : Stepper 컴포넌트의 다음 단계로 이동
     */
    moveNextStep(){

      // Validation 플래그
      let valid = true
      let empty = true

      let tempList = {}
      let result = []

      let currIdx = 0

      switch(this.step){
        case 1: // 보내는 사람정보

          // 값 체크를 위한 ref 리스트
          tempList = [
            this.$refs.shipperNameRef,
            this.$refs.shipperMobileRef,
            this.$refs.shipperAddressRef,
          ]

          result = this.$checkEmptyRefList(tempList)
          if(result.length > 0){
            empty = false
            break
          }

          result = this.$checkInvalidRefList(tempList)
          if(result.length > 0){
            valid = false
            break
          }
          break
        case 2: // 받는 사람정보

          // 값 체크를 위한 ref 리스트
          tempList = [
            this.$refs.receiverTypeRef,
            this.$refs.receiverNameRef,
            this.$refs.receiverTelRef,
            this.$refs.receiverMobileRef,
            this.$refs.receiverZipcodeRef,
            this.$refs.receiverAddress1Ref,
            this.$refs.receiverAddress2Ref,
            this.$refs.pccRef,
          ]

          result = this.$checkEmptyRefList(tempList)
          if(result.length > 0){
            empty = false
            break
          }

          result = this.$checkInvalidRefList(tempList)
          if(result.length > 0){
            valid = false
            break
          }
          break

        case 3: // 오더 상품정보
          if(this.regType === 'customer')
          for(let i=0; i<this.itemList.length; i++){
            currIdx = i + 1
            let itemUnitComp = this.$refs.orderItemRegiFormUnitRef[i]
            let checkResult = itemUnitComp.checkItemData()
            if(!checkResult.empty && empty){
              empty = false
              result = checkResult.result
              break
            }
            if(!checkResult.valid && valid){
              valid = false
              result = checkResult.result
              break
            }
          }
          break
        case 4: // 오더 상품정보

          for(let i=0; i<this.itemList.length; i++){
            currIdx = i + 1
            let itemUnitComp = this.$refs.orderItemRegiFormUnitRef[i]
            let checkResult = itemUnitComp.checkItemData()
            if(!checkResult.empty && empty){
              empty = false
              result = checkResult.result
              break
            }
            if(!checkResult.valid && valid){
              valid = false
              result = checkResult.result
              break
            }
          }
          break
      }

      if(!empty){
        let msg = `${this.step === 4? currIdx + '번째 상품의 ' : ''} ${result.join(',\n ')} 을 입력해주세요.`
        this.$q.dialog({
          message: msg,
        })
        return false
      }

      if(!valid){
        let msg = `${this.step === 4? currIdx + '번째 상품의 ' : ''} ${result.join(',\n ')} 을 올바르게 입력해주세요.`
        this.$q.dialog({
          message: msg,
        })
        return false
      }

      if(this.regType === 'customer'){
        if(this.step === 3){
          this.preValidateOrderForm()
        }
      } else {
        if(this.step === 4){
          this.preValidateOrderForm()
        }
      }


      this.$log.debug("moveNextStep result =", result)
      
      if(result){
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        this.$refs.stepper.next()
      }
    },


    /**
     * Title        : 다음 단계로 이동
     * Status       : Actived
     * Description  : Stepper 컴포넌트의 이전 단계로 이동
     */
    movePrevStep() {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      this.$refs.stepper.previous()
    },

    /**
     * Title        : 초기화
     * Status       : Actived
     * Description  : 컴포넌트 초기화
     *               - Selectbox 데이터 호출
     */
    init() {
      // Selectbox 호출
      // 운송수단
      this.$getFreightList()
      // 배송사
      this.$getCourierList()
    
      // 초기화
      this.itemList = [ this.itemListOrigin ] // 초기화
    }
  },

  mounted() {
    this.$log.debug("PATH !!", this.$route.path.split('/')[1])
    this.regType = 'admin' === this.$route.path.split('/')[1] ? 'admin' : 'customer';
    
    this.init()
  },
}

</script>

<template> 

  <!-- Order 등록 -->
  <q-stepper
    v-model="step"
    ref="stepper"
    alternative-labels
    color="primary"
    animated
    id="stepper"
  >

    <q-step
      :name="0"
      title="약관 동의"
      icon="agree"
      :done="step > 0">

      <q-banner
        v-if="regType === 'customer'"
        rounded
        class="customer-guide-card q-mb-lg">
        <template #avatar>
          <q-icon name="info" color="primary" />
        </template>
        배송요청 전 통관, 금액, 포장, 금지품목 관련 유의사항을 확인해 주세요.
        요청 정보가 부정확하면 통관 또는 배송이 지연될 수 있습니다.
      </q-banner>

      <div class="row q-gutter-sm justify-center q-my-md">
        <div class="col col-min-w col-12 col-md-8">
          <ol id="terms">
            <li>
              내품가(NEW,USED)가 USD 150.00 초과할 경우 과세되며, 내품가격의 측정은 발송인 본인의 책임하에 작성합니다.
              이로 인하여 발생하는 <strong>통관불가/가격 불인정</strong>으로 인한 <strong>통관지연 / 내품분할 / 배송지연</strong> 등에 대하여 보내는 사람에게
              모든 책임이 있음을 확인합니다.
            </li>
            <li>
              송장의 정확한 작성은 발송자의 책임이고, <strong>제조사, 제품명, 수량, 가격</strong> 등을 정확하게 기재하여야 하며. 부실하게 작성된
              부분에 있어서 택배사에서 발송자의 동의 없이 내용을 보완할 수 있습니다. 이로 인해서 발생한 직접, 간접적 피해해 대하여
              택배사는 <strong>책임지지 않습니다.</strong>
            </li>
            <li>
              화물의 포장은 <strong>보내는 사람 책임</strong>이고, 내품은 움직임이 없이 고정되어야 합니다. 유리병 및 파손위험이 높은 경우 보내는사람은
              택배사로 <strong>파손면책동의</strong>를 한 것으로 인정 됩니다.
            </li>
            <li>
              분실을 제외한 <strong>화물의 파손, 오염</strong>의 경우 화물 포장이 완전하지 않은 상태로 발송된 것으로 간주되며 이에 대한 클레임은 택배사에서
              진행되지 않습니다.
            </li>
            <li>
              베터리 및 화기성 제품은 발송할 수 없으며, 만약 속여서 발송하는 과정에서 적발시에 민 형사상의 책임은 전적으로 보내는 사람에게 있습니다.
            </li>
            <li>
              국제택배의 특성상 비행기의 <strong>OFF LOAD, 통관지연, 택배사가 개입할 수 없는 파업, 천재지변</strong> 등으로 발생한 배송지연에 대해서 택배사는 보상하지 않습니다.
            </li>
            <li>
              발송하는 택배화물에 대한 대한민국 내의 모든 통관 규정을 숙지하였으며, <strong>규정에 벗어난</strong> 사항으로 인하여 발생하는 직/간적접인
              <strong>책임은 발송자 본인에게</strong> 있음을 인정합니다.
            </li>
          </ol>
        </div>
      </div>
    </q-step>
    
    <q-step
      :name="1"
      title="보내는 사람정보"
      icon="file_upload"
      :done="step > 1">
      <q-banner
        v-if="regType === 'customer'"
        rounded
        class="customer-guide-card q-mb-lg">
        <template #avatar>
          <q-icon name="flight_takeoff" color="primary" />
        </template>
        보내는 사람은 호주 발송인 정보입니다. 이름과 주소는 영문으로 입력해 주세요.
      </q-banner>
      <div class="row q-col-gutter-sm">
        <div class="col col-min-w col-xs-12 col-sm-6">
          <q-input
            v-model="orderForm.shipperName"
            ref="shipperNameRef"
            label="보내는 사람 이름(영문)"
            :rules="[
              this.$validationSet.alpha
            ]" />
        </div>
        <div class="col col-min-w col-xs-12 col-sm-6">
          <q-input
            v-model="orderForm.shipperMobile"
            ref="shipperMobileRef"
            type="tel"
            inputmode="tel"
            maxlength="11"
            label="보내는 사람 전화번호"
            :rules="[this.$validationSet.num]" />
        </div>
        <div class="col col-min-w col-12">
          <q-input
            v-model="orderForm.shipperAddress"
            ref="shipperAddressRef"
            type="textarea"
            :rows="2"
            label="보내는 사람 주소(영문)"
            :rules="[this.$validationSet.engAddr]" />
        </div>
      </div>
    </q-step>

    <q-step
      :name="2"
      title="받는 사람정보"
      icon="file_download"
      :done="step > 2"
    >
      <q-banner
        v-if="regType === 'customer'"
        rounded
        class="customer-guide-card q-mb-lg">
        <template #avatar>
          <q-icon name="home" color="primary" />
        </template>
        받는 사람은 한국 수취인 정보입니다. 이름과 주소는 한글로 입력하고,
        개인 배송은 개인통관고유부호를 정확히 입력해 주세요.
      </q-banner>
      <div class="row q-gutter-sm">
        <div class="col col-min-w">
          <q-select 
            v-model="orderForm.receiverType"
            ref="receiverTypeRef"
            :options="[
              { label: '개인', value: '1' },
              { label: '사업자', value: '2' }
            ]"
            label="받는 사람구분" 
            emit-value
            map-options
            behavior="menu"/>
        </div>
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.receiverName"
            ref="receiverNameRef"
            label="받는 사람 이름(한글)"
            :rules="[this.$validationSet.korean]" />
        </div>
      </div>

      <div class="row q-gutter-sm">
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.receiverTel"
            ref="receiverTelRef"
            maxlength="11"
            type="tel"
            :rules="[this.$validationSet.maxLength(11)]"
            label="받는 사람 전화" />
        </div>
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.receiverMobile"
            ref="receiverMobileRef"
            maxlength="11"
            type="tel"
            :rules="[this.$validationSet.maxLength(11)]"
            label="받는 사람 휴대폰" />
        </div>
      </div>
      
      <div class="row q-gutter-sm q-mb-lg">
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.pcc"
            ref="pccRef"
            maxlength="13"
            :rules="[this.$validationSet.maxLength(13)]"
            label="개인통관고유부호" />
        </div>
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.receiverZipcode"
            ref="receiverZipcodeRef"
            maxlength="5"
            type="tel"
            :rules="[val => val.length === 5 || '5자리를 입력하세요']"
            label="받는 사람 우편번호" />
        </div>
      </div>

      <div class="row q-gutter-sm q-mb-lg">
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.receiverAddress1"
            ref="receiverAddress1Ref"
            label="받는 사람 주소(한글)"
            :rules="[this.$validationSet.korAddr]" />
        </div>
        <div class="col-12">
          <q-input
            v-model="orderForm.receiverAddress2"
            ref="receiverAddress2Ref"
            label="받는 사람 상세주소(한글)"
            :rules="[this.$validationSet.korAddr]" />
        </div>
      
        <div class="col-12">
          <q-input
            v-model="orderForm.orderMemo"
            maxlength="400"
            type="textarea"
            :rows="2"
            :rules="[val => val.length <= 400 || '최대 400자까지 입력 가능합니다.']"
            label="배송메모" />
        </div>
      </div>

      <div class="row q-gutter-sm q-mt-sm">
        <div class="col col-min-w">
          <q-input
            v-model="orderForm.weight"
            type="number"
            min="0.001"
            step="any"
            label="중량(kg)"
            :rules="[
              val => val === null || val === undefined || val === '' || Number(val) >= 0 || '중량은 0 이상이어야 합니다.'
            ]" />
        </div>
      </div>

    </q-step>

    <q-step
      v-if="regType === 'admin'"
      :name="3"
      title="기본정보"
      icon="list"
      :done="step > 3"
    >
      <div class="row">
        <!--
        <div class="col-3">
          <q-select 
            v-model="orderForm.freightMethod"
            :options="this.$store.getters.getFreightMethodList"
            label="운송수단" 
            emit-value
            map-options
            behavior="menu"/>
        </div>
        -->
        
        <div class="col-sm-6 col-xs-12">
          <q-input
            v-model="orderForm.orderId"
            class="f-width"
            label="Order No." />
        </div>
        
        <!--
        <div class="col-sm-6 col-xs-12">
          <q-input
            v-model="orderForm.hblNo"
            label="HBL 번호"
            placeholder="등록시 자동 채번이 됩니다"
            disable />
        </div>
        -->
        
      </div>

      <div class="row q-gutter-sm">
        <div class="col col-min-w">
          <q-select 
            v-model="orderForm.needClearance" 
            :options="[
              { label: '목록', value: 'Y' },
              { label: '일반', value: 'N' },
            ]"
            label="일반신청" 
            emit-value
            map-options
            behavior="menu"
            disable />
        </div>

        <div class="col col-min-w">
          <q-select 
            v-model="orderForm.customsCategory"
            :options="[
              { label: '전자상거래', value: 'A' },
              { label: '개인', value: 'D' },
              { label: '상업상품', value: 'E' },
              { label: '상업서류', value: 'F' }
            ]"
            label="통관구분" 
            emit-value
            map-options
            behavior="menu"
            disable />
        </div>
      </div>

    </q-step>

    <q-step
      :name="regType === 'admin' ? 4 : 3"
      title="상품정보"
      icon="add_comment"
    >
      <q-banner
        v-if="regType === 'customer'"
        rounded
        class="customer-guide-card q-mb-lg">
        <template #avatar>
          <q-icon name="inventory_2" color="primary" />
        </template>
        상품명, 브랜드, 수량, 단가는 통관 기준 정보입니다. 총 금액이 USD 150을 초과하면 과세될 수 있습니다.
      </q-banner>
      <div class="row q-mb-sm q-mt-lg">
        <div class="col">
          <q-btn 
            dense flat icon="add_circle"
            @click="() => { itemList.push(
              {
                barcode: '',             // 바코드
                itemName: '',            // 품명 (필수)
                brand: '',               // 브랜드
                itemQty: '',              // 수량
                unit: '',                // 단위 (예: 개, 박스 등)
                currency: 'USD',         // 통화 (예: USD, KRW)
                unitPrice: '',            // 단가
                weight: 10.00,            // 중량 (kg)
                height: 10.00,            // 높이 (cm)
                length: 10.00,            // 길이 (cm)
                width: 0.00,             // 넓이 (cm)
                volumeWeight: 0.000,     // 볼륨중량 (자동 계산 가능)
                url: '',                 // 상품 URL
                hsCode: '',              // HS CODE
              }
            );
            confirmed = false }">
            <span class="q-ml-xs">상품 추가</span>
          </q-btn>
        </div>
        <div class="col flex justify-end items-center">
          총 금액: <span :class="totalItemPrice > 149 ? 'text-orange': ''"> {{ totalItemPrice }}</span>
        </div>
      </div>

      <div class="row q-mb-sm q-gutter-sm flex flex-wrap">
        <div 
          class="col"
          style="min-width: 300px;"
          v-for="(item, idx) in itemList"
          :key="item.id ?? idx">
          <OrderItemRegiFormUnit
            ref="orderItemRegiFormUnitRef"
            :idx="idx"
            :item="item"
            :show-barcode="canUseFulfillmentBarcode"
            :partner-id="partnerId"
            :enable-hs-code-auto="regType === 'admin'"
            @remove-row="removeRow"
            @update-item="updateItemAt(idx, $event)" />
        </div>
      </div>
    </q-step>

    <template v-slot:navigation>
      <q-stepper-navigation class="flex justify-center items-center">
        <q-toolbar>

          <q-btn 
            v-show="step > 0" 
            size="md"
            color="primary" 
            @click="movePrevStep" 
            outline
            label="이전" 
            class="full-width q-mr-sm" />
          <q-btn 
            v-show="step < (regType === 'admin' ? 4 : 3)"
            size="md"
            @click="moveNextStep"
            color="primary" 
            class="full-width"
            :label="step === 0 ? '동의합니다' : '다음'" />

          <q-btn
            v-show="step === (regType === 'admin' ? 4 : 3) && !confirmed"
            size="md"
            :label="regType === 'customer' ? '입력내용 확인' : 'ORDER 검증'"
            color="secondary"
            @click="moveNextStep"
            class="full-width" />

          <q-btn
            v-show="confirmed"
            size="md"
            :label="regType === 'customer' ? '배송요청 제출' : 'ORDER 등록'"
            color="primary"
            type="button"
            @click="regOrder"
            class="full-width" />
        </q-toolbar>
      </q-stepper-navigation>
    </template>
  </q-stepper>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#stepper {
  box-shadow: none;
}
.parcel-unit {
  min-width: 300px;
  max-width: 400px;
}

#terms {
  li {
    margin-bottom: 10px;
    line-height: 1.5;
  }
}

.customer-guide-card {
  border: 1px solid #dce7f5;
  background: #f7fbff;
  color: #26384f;
}
</style>
